<template>
    <div>
        <form-wrapper :validator="{}" class="form-wrapper">
            <div class="information-box">
                <TeamMemberCustomFields :value="member.customFields" @changed="handleCustomFieldChanged" />
            </div>

            <div class="custom-section-wrapper">
                <md-button type="submit" class="md-primary pull-right" @click="update">Save</md-button>
            </div>
        </form-wrapper>
    </div>
</template>

<script>
import { compareProperties } from '@/helpers';
import _ from 'lodash';
import { TeamMemberCustomFields } from '@/components';

export default {
    name: 'MemberDocument',
    components: {
        TeamMemberCustomFields
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        isAllowedToUpdate: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            member: { customFields: {} }
        };
    },
    mounted() {
        this.member = _.cloneDeep(this.data);
    },

    watch: {
        data: {
            handler(newVal) {
                this.member = _.cloneDeep(newVal);
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        handleCustomFieldChanged(updatedValue) {
            this.member.customFields = { ...updatedValue };
        },
        update() {
            this.$emit('updated', this.member);
        },
        hasChanges() {
            return !compareProperties(this.member, this.data, ['customFields']);
        }
    }
};
</script>

<style lang="scss" scoped>
.form-wrapper {
    padding: 0 15px;
    max-width: 700px;
}
.custom-section-wrapper {
    h5 {
        font-weight: 500;
        text-transform: uppercase;
        font-size: 12px;
    }
    .custom-form-group {
        margin-bottom: 20px;
        width: 60%;
        display: inline-block;
        padding-right: 30px;
        vertical-align: top;
    }
    .date-form-group {
        width: 250px;
    }
}

.custom-section-wrapper:last-child {
    border: none;
}

::v-deep fieldset {
    border: dashed 1px lightgrey;
    margin-bottom: 10px;

    legend {
        font-size: 1rem;
        font-weight: 100;
        margin-bottom: 10px;
    }
}
</style>
